import React from 'react'
import { View, StyleSheet } from 'react-native'
import AppHeader from './AppHeader'
import bg from './images/background.png'

const AppContainer = ({ headerOptions, style, children }) => (
  <View style={[styles.container, style]}>
    <AppHeader {...headerOptions} />
    {children}
  </View>
)

const styles = StyleSheet.create({
  container: {
    minHeight: '100vh',
    backgroundImage: `url(${bg})`,
  },
})

export default AppContainer
